"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = default_1;
function default_1() {
    var xhr = new XMLHttpRequest();
    if (xhr.onload !== undefined) {
        return xhr;
    }
    var xdr = {
        open: function (method, url, async, user, password) { return xhr.open(method, url, async, user, password); },
        send: function (data) { return xhr.send(data); },
        abort: function () { return xhr.abort(); },
        setRequestHeader: function (header, value) {
            return xhr.setRequestHeader(header, value);
        },
        addEventListener: function (type, listener, useCapture) { return xhr.addEventListener(type, listener, useCapture); },
        getResponseHeader: function (header) { return xhr.getResponseHeader(header); },
        getAllResponseHeaders: function () { return xhr.getAllResponseHeaders(); },
        readyState: 0,
        timeout: 0,
    };
    xhr.onreadystatechange = function (ev) {
        if (xhr.readyState !== 4)
            return;
        xdr.readyState = xhr.readyState;
        xdr.responseText = xhr.responseText;
        xdr.responseXML = xhr.responseXML;
        xdr.status = xhr.status;
        xdr.statusText = xhr.statusText;
        if (xdr.onreadystatechange) {
            xdr.onreadystatechange(ev);
            return;
        }
        if (xhr.status < 200 || xhr.status >= 300) {
            xdr.onerror && xdr.onerror(ev);
        }
        else if (xdr.onload) {
            xdr.onload(ev);
        }
    };
    xhr.ontimeout = function (ev) {
        if (xdr.ontimeout)
            xdr.ontimeout(ev);
    };
    return xdr;
}
